/**
 * @generated SignedSource<<d825ce4fb20b11b834d1c885c63add90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductKind = "License";
export type ProductsSelect_QueryFragmentRefetchQuery$variables = {
  after?: string | null;
  first?: number | null;
  inKinds?: ReadonlyArray<ProductKind> | null;
  productIds: ReadonlyArray<string>;
  title?: string | null;
};
export type ProductsSelect_QueryFragmentRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductsSelect_QueryFragment">;
};
export type ProductsSelect_QueryFragmentRefetchQuery = {
  response: ProductsSelect_QueryFragmentRefetchQuery$data;
  variables: ProductsSelect_QueryFragmentRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": [
      "License"
    ],
    "kind": "LocalArgument",
    "name": "inKinds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "inKinds",
  "variableName": "inKinds"
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "titleOpt",
    "variableName": "title"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductsSelect_QueryFragmentRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "Variable",
            "name": "productIds",
            "variableName": "productIds"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ProductsSelect_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductsSelect_QueryFragmentRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillingAdminSchema",
            "kind": "LinkedField",
            "name": "Billing",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "ProductsConnection",
                "kind": "LinkedField",
                "name": "SearchProducts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": [
                  "titleOpt",
                  "inKinds"
                ],
                "handle": "connection",
                "key": "ProductsSelect_SearchProducts",
                "kind": "LinkedHandle",
                "name": "SearchProducts"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "ids",
            "variableName": "productIds"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/)
            ],
            "type": "Product",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f845d22bc75a6f7864fef5bd0eff4887",
    "id": null,
    "metadata": {},
    "name": "ProductsSelect_QueryFragmentRefetchQuery",
    "operationKind": "query",
    "text": "query ProductsSelect_QueryFragmentRefetchQuery(\n  $after: String = null\n  $first: Int\n  $inKinds: [ProductKind!] = [License]\n  $productIds: [ID!]!\n  $title: String = null\n) {\n  ...ProductsSelect_QueryFragment_3IcBJS\n}\n\nfragment ProductsSelect_QueryFragment_3IcBJS on Query {\n  Admin {\n    Billing {\n      SearchProducts(first: $first, after: $after, titleOpt: $title, inKinds: $inKinds) {\n        edges {\n          cursor\n          node {\n            id\n            title\n            __typename\n          }\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n  }\n  nodes(ids: $productIds) {\n    __typename\n    ... on Product {\n      id\n      title\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1fa0844ff3bc07d6f653bbcfcd6d7415";

export default node;
